export const getLastArrayItem = <T>(array: Array<T>) => {
  return array?.at(-1) as T
}
